export const isOverall = (moduleId: string|undefined) => ( !moduleId || moduleId.toLowerCase() === 'overall' )
